<template>

  <div class="card">
    <div class="row">
      <div class="col-md-10">
        <h5>Contactos</h5>
      </div>
      <div class="col-md-2">
        <button class="btn btn-primary btn-raised" type="button" @click="save">Guardar</button>
      </div>
    </div>
    <hr>
    <div class="row text-center">
      <div class="col-md-12">
        <h5>Director General</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 text-left">
        <label>Nombre Completo</label>
        <input type="text" class="form-control" v-model="general.name">
      </div>
      <div class="col-md-4 text-left">
        <label>Correo</label>
        <input type="text" class="form-control" v-model="general.email">
      </div>
      <div class="col-md-4 text-left">
        <label>Teléfono</label>
        <input type="text" class="form-control" v-model="general.phone">
      </div>
    </div>
    <br>
    <div class="row text-center">
      <div class="col-md-12">
        <h5>Director Comercial</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 text-left">
        <label>Nombre Completo</label>
        <input type="text" class="form-control" v-model="commerce.name">
      </div>
      <div class="col-md-4 text-left">
        <label>Correo</label>
        <input type="text" class="form-control" v-model="commerce.email">
      </div>
      <div class="col-md-4 text-left">
        <label>Teléfono</label>
        <input type="text" class="form-control" v-model="commerce.phone">
      </div>
    </div>
    <br>
    <div class="row text-center">
      <div class="col-md-12">
        <h5>Director de Operaciones</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 text-left">
        <label>Nombre Completo</label>
        <input type="text" class="form-control" v-model="operations.name">
      </div>
      <div class="col-md-4 text-left">
        <label>Correo</label>
        <input type="text" class="form-control" v-model="operations.email">
      </div>
      <div class="col-md-4 text-left">
        <label>Teléfono</label>
        <input type="text" class="form-control" v-model="operations.phone">
      </div>
    </div>
  </div>

</template>

<script lang="js">
  export default  {
    name: 'supplier-contacts',
    props: ['id_supplier', 'usuario'],
    mounted() {
      axios.get('/api/supplier/contacts/' + this.id_supplier).then(response => {
        this.general = response.data.general
        this.commerce = response.data.commerce
        this.operations = response.data.operations
      })
    },
    data() {
      return {
        general:{},
        commerce: {},
        operations:{},
      }
    },
    methods: {
      save(){
        if(this.validate()){
          Vue.toasted.show('Guardando...', { position: 'bottom-center', closeOnSwipe: false });
          axios.post('/api/supplier/contacts/' + this.id_supplier, {
            general: this.general,
            commerce: this.commerce,
            operations: this.operations
          }).then(response => {
            Vue.toasted.clear()
            Vue.toasted.show('Información guardada!!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 2000 })
          }).catch(error => {
            Vue.toasted.clear()
            Vue.toasted.show('Parece que ha ocurrido un error, inténtalo de nuevo', { position: 'bottom-center', type:'error', closeOnSwipe: true})
          })
        }
      },
      validate(){
        let u = this;
        var fill = ''
        var fields = []
        if(u.general.name == '' || u.general.phone == '' || u.general.email == ''){
          if(u.general.name != '' || u.general.phone != '' || u.general.email != ''){
            fields.push('Director General')
          }
        }
        if(u.commerce.name == '' || u.commerce.phone == '' || u.commerce.email == ''){
          if(u.commerce.name != '' || u.commerce.phone != '' || u.commerce.email != ''){
            fields.push('Director Comercial')
          }
        }
        if(u.operations.name == '' || u.operations.phone == '' || u.operations.email == ''){
          if(u.operations.name != '' || u.operations.phone != '' || u.operations.email != ''){
            fields.push('Director de Operaciones')
          }
        }
        fill = fields.join(', ')
        if (fill == ''){
          return true
        }else{
          Vue.toasted.clear()
          Vue.toasted.show('Ingresa todos los datos de ' + fill, { position: 'bottom-center', type:'error', closeOnSwipe: true})
          return false
        }
      }
    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .supplier-contacts {

  }
  .row{
    margin-top: 15px;
  }
  .card{
    padding: 0 10px;
  }
</style>
